var n, v;
function l() {
  if (v) return n;
  v = 1;
  function f() {
    for (var r, t = [], e = 0; e < 256; e++) {
      r = e;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      t[e] = r;
    }
    return t;
  }
  var o = f();
  function i(r, t, e, a) {
    var c = o, b = a + e;
    r ^= -1;
    for (var u = a; u < b; u++)
      r = r >>> 8 ^ c[(r ^ t[u]) & 255];
    return r ^ -1;
  }
  return n = i, n;
}
export {
  l as __require
};
//# sourceMappingURL=crc32.es.js.map
